export default "__VITE_PUBLIC_ASSET__990dde1a__"